import img1 from '../Components/Images/Customers/jaspreet singh.webp';
import img2 from '../Components/Images/Customers/Manjeet Singh.jpg';
import img3 from '../Components/Images/Customers/Anmol Chaudhary.jpg';
import img4 from '../Components/Images/Customers/Ashish Bansal.jpg';
import img5 from '../Components/Images/Customers/Ajab Singh.jpg';
import img6 from '../Components/Images/Customers/dr puneet garg.png';

export const testimonialContent = [
    {
        id : 1,
        img : img1,
        name : "Jaspreet Singh",
        rating : '⭐⭐⭐⭐⭐',
        review : "Buying my Kia Seltos from theCarzilla.in was an absolute breeze! The seamless process, coupled with their excellent customer service, made my car buying experience truly delightful. I'm loving every moment in my new ride!",
    },
    {
        id : 2,
        img : img2,
        name : "Manjeet Singh",
        rating : '⭐⭐⭐⭐⭐',
        review : "Choosing the Honda Elevate from theCarzilla.in was a decision I'll never regret. From their extensive selection to their impeccable service, theCarzilla.in made my car buying journey smooth and satisfying.",
    },
    {
        id : 3,
        img : img3,
        name : "Anmol Chaudhary",
        rating : '⭐⭐⭐⭐⭐',
        review : "Getting my Tata Punch from theCarzilla.in was a fantastic choice! Their seamless process and knowledgeable staff made purchasing my dream car a breeze. I'm thrilled with my Tata Punch and couldn't be happier with theCarzilla.in's service!",
    },
    {
        id : 4,
        img : img4,
        name : "Ashish Bansal",
        rating : '⭐⭐⭐⭐⭐',
        review : "Selecting TheCarzilla.in for my XL6 purchase was exceptional. The staff were professional, knowledgeable, and genuinely cared about finding the perfect car for me at the right price. I highly recommend TheCarzilla.in to anyone looking to buy a car.",
    },
    {
        id : 5,
        img : img5,
        name : "Ajab Singh",
        rating : '⭐⭐⭐⭐⭐',
        review : "I recently bought my Kia Seltos from TheCarzilla.in, a decision I don't regret. Their team secured an unbeatable deal at a convenient store, making the process smooth. Thanks to them, I'm cruising in my dream car, saving money too.",
    },
    {
        id : 6,
        img : img6,
        name : "Dr. Puneet Garg",
        rating : '⭐⭐⭐⭐⭐',
        review : "Purchasing my dream car, the Tago EV, from TheCarzilla.in was an amazing experience. Their commitment to great prices made me and my family thrilled. They solved all past buying problems. TheCarzilla.in is a name you can trust for car purchases.",
    }
];